import React from "react";
import Chip from "@material-ui/core/Chip";

const EventStatusChip = ({ evento, className }) => {
  const disponible = Number(evento && evento.eventoDisponible);

  if (disponible === 4) {
    return (
      <Chip
        size="small"
        label="En vivo"
        style={{ backgroundColor: "#d32f2f", color: "#fff" }}
        className={className}
      />
    );
  }

  if (disponible === 2) {
    return (
      <Chip size="small" label="Próximo" color="primary" className={className} />
    );
  }

  return null;
};

export default EventStatusChip;
